import {configureStore} from '@reduxjs/toolkit'
import appReducer from "../reducers/appSlice";

const preloadedState = {};

export default configureStore({
    reducer: { app: appReducer },
    preloadedState
})